import { StepSection } from "./StepSection.component.tsx";

export default StepSection;
